import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Logo } from '../Logo';
import { Icon } from '../Icon';
import defaultLogoSrc from '../../assets/images/boundly-logo-dark-new.png';
import styles from './HeaderV6.css';

const cx = classnames.bind(styles);

function HeaderV6({ className, renderLeftNavigation, url, isFinished, progressBar, questionNav, hasBackButton, onBack, logoSrc }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    const wrapperClasses = cx({ wrapper: true, finished: isFinished });

    const renderBackButton = () => (
        <button
            type='button'
            className={styles.backButton}
            onClick={() => onBack()}
            aria-label='Go back'
        >
            <Icon name='arrowLeft' />
        </button>
    );

    return (
        <header className={classes}>
            {questionNav ? (
                <nav className={styles.questionNav}>
                    <div className={styles.navSide}>
                        {hasBackButton && renderBackButton()}
                    </div>
                    <p className={styles.category}>{questionNav.category}</p>
                    <div className={cx('navSide', 'navSideRight')}>
                        {questionNav.hasCounter && (
                            <span className={styles.counter}>{questionNav.currentSlideIndex} / {questionNav.totalSlides}</span>
                        )}
                    </div>
                </nav>
            ) : (
                <div className={wrapperClasses}>
                    {hasBackButton && renderBackButton()}
                    <Logo url={url} src={logoSrc || defaultLogoSrc} className={cx({ logo: true, finished: isFinished })} />
                    {Boolean(renderLeftNavigation) && renderLeftNavigation()}
                </div>
            )}
            {Boolean(progressBar) && progressBar}
        </header>
    );
}

HeaderV6.propTypes = {
    className: PropTypes.string,
    renderLeftNavigation: PropTypes.func,
    url: PropTypes.string.isRequired,
    isFinished: PropTypes.bool.isRequired,
    progressBar: PropTypes.node,
    questionNav: PropTypes.shape({
        category: PropTypes.node,
        hasCounter: PropTypes.bool,
        currentSlideIndex: PropTypes.number,
        totalSlides: PropTypes.number
    }),
    hasBackButton: PropTypes.bool,
    onBack: PropTypes.func,
    logoSrc: PropTypes.string
};

HeaderV6.defaultProps = {
    className: '',
    renderLeftNavigation: null,
    progressBar: null,
    questionNav: null,
    hasBackButton: false,
    onBack: null,
    logoSrc: null
};

export {
    HeaderV6
};
